import {Typography} from 'components/Typography';
import React, {FC} from 'react';
import style from './style.module.scss';
import classNames from 'classnames';
import {Tooltip} from 'components/Tooltip';

interface IProps {
    className?: string;
}

export const ShieldBySimple: FC<IProps> = ({className}) => {
    return (
        <div className={classNames(style.main, className)}>
            <Tooltip
                overlay={
                    <div className={style.tooltipContent}>
                        <Typography variant={'label-14-r'}>
                            Это наша франшиза: в винотеке всё устроено, как в SimpleWine, и такой же ассортимент
                        </Typography>
                    </div>
                }
                place={'bottom'}
            >
                <Typography variant={'label-12-r'}>by Simple</Typography>
            </Tooltip>
        </div>
    );
};
